import ErrorMessage from './ErrorMessage'
import Image from '../Image'
import CustomPhoneInput from '../PhoneInput/PhoneInput'
import HorizontalCheckBox from '../HorizontalCheckBox/HorizontalCheckBox'
import VerticalCheckList from '../VerticalCheckList/VerticalCheckList'
import ImageWithTextArea from '../ImageWithTextArea/ImageWithTextArea'
import styles from './formikform.module.scss'
import Selector from '../Select'

export default class FieldFactory {
    static getFormField(fieldInfo, formikProps, fieldInfos, countriesObj, countries) {
        switch (fieldInfo.type) {
            case 'text':
                return this.#getTextField(fieldInfo, formikProps)
            case 'input_image':
                return this.#getImageWithTextArea(fieldInfo, formikProps)
            case 'textarea':
                return this.#getTextAreaField(fieldInfo, formikProps)
            case 'phone':
                return this.#getPhoneNumField(fieldInfo, formikProps)
            case 'password':
                return this.#getPasswordField(fieldInfo, formikProps)
            case 'number':
                return this.#getNumberField(fieldInfo, formikProps)
            case 'image':
                return this.#getImageField(fieldInfo, formikProps)
            case 'horizontal_check_box':
                return this.#getHorizontalCheckBox(fieldInfo, formikProps)
            case 'vertical_check_list':
                return this.#getVerticalCheckList(fieldInfo, formikProps)
            case 'dropdown':
                return this.#getDropDown(fieldInfo, formikProps, fieldInfos, countriesObj, countries)
            case 'date':
                return this.#getDateField(fieldInfo, formikProps)
            default:
                break
        }
    }

    static states = [];

    static #isInvalidCss(fieldInfo, formikProps) {
        return formikProps.touched[fieldInfo.name] ?
            formikProps.errors[fieldInfo.name]
                ? ' is-invalid'
                : ' is-valid' : ''
    }

    static #getDropDown(fieldInfo, formikProps, fieldInfos, countriesObj, countries){
        console.log(" this.states?.length <= 0 ", this.states?.length <= 0)
        console.log(" formikProps.values.country?.value ", formikProps.values.country?.value)
        console.log(" fcountriesObj?.length>0 ", countriesObj?.length>0)

        if(this.states?.length <= 0 && formikProps.values.country?.value && countriesObj?.length>0){
            const selectedStates = (countriesObj.find(obj => obj.country === formikProps.values.country?.value))?.states || [];
            this.states = selectedStates.map(obj => {
                return {value:obj, label:obj}
            });
        }
        return(
            <div className='m-2 w-100' key={fieldInfo.slug}>
                <label htmlFor={fieldInfo.name}
                   className={styles.label}>{fieldInfo.label}</label>
                <Selector value={formikProps.values[fieldInfo.slug]}
                          options={fieldInfo.slug=== 'country'? countries: fieldInfo.slug=== 'state'? this.states: fieldInfo.options}
                          onChange={(option)=> {
                              console.log('getDropDown option ', option)
                              formikProps.setFieldValue(fieldInfo.slug,option?.target?.value)
                              if(fieldInfo.slug === 'country' && formikProps.values[fieldInfo.slug]?.value !== option?.target?.value?.value){
                                  formikProps.setFieldValue('state', {})
                                  const selectedStates = (countriesObj.find(obj => obj.country === option?.target?.value?.value))?.states || [];
                                  this.states = selectedStates.map(obj => {
                                      return {value:obj, label:obj}
                                  });

                              }
                          }}
                          onBlur={()=>formikProps.setFieldTouched(fieldInfo.slug, true)}
                          className={`form-control pl-0 pt-0 pb-0 ${this.#isInvalidCss(
                              fieldInfo,
                              formikProps,
                          )} ${styles.dropDownStyle}`}
                />{/*select__control css-yk16xz-control */}
                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>

        )
    }
    static #getVerticalCheckList(fieldInfo, formikProps) {
        console.log('fieldInfo ', fieldInfo)
        return (
            <div className='m-2 w-100' key={fieldInfo.slug}>
                <label htmlFor={fieldInfo.name}
                       className={styles.label}>{fieldInfo.label}</label>

                <VerticalCheckList fieldInfo={fieldInfo}
                                   value={formikProps.values[fieldInfo.slug]}
                                   onChange={(value) => {
                                       const index = formikProps.values[fieldInfo.slug].indexOf(value)
                                       let formikValue = [...formikProps.values[fieldInfo.slug]]
                                       console.log('formikValue', formikValue)
                                       console.log('index', index)
                                       if (index >= 0) {
                                           formikValue.splice(index, 1)
                                       } else {
                                           formikValue.push(value)
                                       }
                                       console.log('new formikValue', formikValue)
                                       formikProps.setFieldValue(fieldInfo.slug, formikValue)
                                   }}
                />
                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>
        )
    }

    static #getHorizontalCheckBox(fieldInfo, formikProps) {
        return (
            <div className='m-2 w-100' key={fieldInfo.slug}>
                <label htmlFor={fieldInfo.name}
                       className={styles.label}>{fieldInfo.label}</label>
                <div
                    className={`form-control ${this.#isInvalidCss(
                        fieldInfo,
                        formikProps,
                    )} ${styles.horizontalDesktopView}`}
                    onBlur={formikProps.handleBlur}
                >
                    <HorizontalCheckBox fieldInfo={fieldInfo}
                                        value={formikProps.values[fieldInfo.slug]}
                                        onChange={(value) => {
                                            console.log("HorizontalCheckBox fieldInfo.slug ", fieldInfo.slug)
                                            console.log("HorizontalCheckBox value ", value)
                                            formikProps.setFieldValue(fieldInfo.slug, value)
                                            setTimeout(()=>{
                                                formikProps.setFieldTouched(fieldInfo.slug, true)
                                            },0)


                                        }}
                    />
                    <ErrorMessage fieldInfo={fieldInfo}
                                  formikProps={formikProps} />
                </div>
            </div>
        )
    }


    static #getTextField(fieldInfo, formikProps) {
        return (
            <div className='m-2 w-100' key={fieldInfo.slug}>
                <label htmlFor={fieldInfo.name}
                       className={styles.label}>{fieldInfo.label}</label>
                <input
                    type='text'
                    placeholder={fieldInfo.placeholder || ''}
                    name={fieldInfo.name}
                    value={formikProps.values[fieldInfo.slug]}
                    onChange={fieldInfo.noHandleChange?(e)=> formikProps.setFieldValue(fieldInfo.slug,e.target.value ) : formikProps.handleChange}
                    onBlur={formikProps.handleBlur}
                    className={`form-control${this.#isInvalidCss(
                        fieldInfo,
                        formikProps,
                    )} ${styles.inputField}`}
                    disabled={fieldInfo.disabled}

                />
                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>
        )
    }

    static #getDateField(fieldInfo, formikProps) {
        return (
            <div className='m-2 w-100' key={fieldInfo.slug}>
                <label htmlFor={fieldInfo.name}
                       className={styles.label}>{fieldInfo.label}</label>
                <input
                    type='date'
                    placeholder={fieldInfo.placeholder || ''}
                    name={fieldInfo.name}
                    value={formikProps.values[fieldInfo.slug]}
                    onChange={formikProps.handleChange}
                    onBlur={formikProps.handleBlur}
                    className={`form-control${this.#isInvalidCss(
                        fieldInfo,
                        formikProps,
                    )} ${styles.inputField}`}
                />
                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>
        )
    }

    static #getImageWithTextArea(fieldInfo, formikProps) {
        return (
            <div className='m-2 w-100' key={fieldInfo.slug}>
                <label htmlFor={fieldInfo.name}
                       className={styles.label}>{fieldInfo.label}</label>

                <ImageWithTextArea
                    formikProps={formikProps}
                    fieldInfo={fieldInfo}
                    name={fieldInfo.name}
                    placeholder={fieldInfo.placeholder || ''}
                    value={formikProps.values[fieldInfo.slug]}
                    onChange={formikProps.handleChange}
                    onBlur={formikProps.handleBlur}
                    className={`form-control${this.#isInvalidCss(
                        fieldInfo,
                        formikProps,
                    )}`}
                    disabled={fieldInfo.disabled}
                />
                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>
        )
    }

    static #getTextAreaField(fieldInfo, formikProps) {
        return (
            <div className={`m-2 ${  styles.textAreaMain}`} key={fieldInfo.slug}>
                {fieldInfo.label !== 'Issue' && <label htmlFor={fieldInfo.name}
                                                       className={styles.label}>{fieldInfo.label}</label>}
                <textarea
                    name={fieldInfo.name}
                    placeholder={fieldInfo.placeholder || ''}
                    value={formikProps.values[fieldInfo.slug]}
                    onChange={formikProps.handleChange}
                    onBlur={formikProps.handleBlur}
                    className={`form-control${this.#isInvalidCss(
                        fieldInfo,
                        formikProps,
                    )} ${styles.textArea}`}
                    disabled={fieldInfo.disabled}
                />
                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>
        )
    }

    static #getPhoneNumField(fieldInfo, formikProps) {
        return (
            <div className='m-2 w-100' key={fieldInfo.slug}>
                <label htmlFor={fieldInfo.name}
                       className={styles.label}>{fieldInfo.label}</label>
                <CustomPhoneInput
                    name={fieldInfo.name}
                    country={'ca'}
                    placeholder='Phone Number'
                    prefix='+'
                    value={formikProps.values[fieldInfo.slug]}
                    copyNumbersOnly={false}
                    onChange={(value) => {
                        console.log("CustomPhoneInput onChange value", value)
                        formikProps.setFieldValue(fieldInfo.slug, value)
                    }}
                    onBlur={()=>formikProps.setFieldTouched(fieldInfo.slug, true)}
                    containerClass={`form-control ${this.#isInvalidCss(
                        fieldInfo,
                        formikProps,
                    )} ${styles.inputField} w-100`}
                />
                {/*<input placeholder={fieldInfo.placeholder || ''}
                       type="tel"
                       value={formikProps.values[fieldInfo.slug]}
                       onChange={(e) => {
                           formikProps.setFieldValue(fieldInfo.slug, e.target.value)
                       }}
                       onBlur={formikProps.handleBlur}
                       className={`form-control ${this.#isInvalidCss(
                    fieldInfo,
                    formikProps,
                )} ${styles.inputField}`}
                />*/}
                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>
        )
    }

    static #getPasswordField(fieldInfo, formikProps) {
        return (
            <div className='m-2 w-100' key={fieldInfo.slug}>
                <label htmlFor={fieldInfo.name}
                       className={styles.label}>{fieldInfo.label}</label>
                <input
                    type='password'
                    name={fieldInfo.name}
                    value={formikProps.values[fieldInfo.slug]}
                    onChange={formikProps.handleChange}
                    onBlur={formikProps.handleBlur}
                    className={`form-control${this.#isInvalidCss(
                        fieldInfo,
                        formikProps,
                    )} ${styles.inputField}`}
                />
                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>
        )
    }

    static #getImageField(fieldInfo, formikProps) {
        return (
            <div style={{
                width: '100%',
                margin: '5',
            }} key={fieldInfo.slug}>
                <Image {...fieldInfo}
                       value={formikProps.values[fieldInfo.slug]}
                    //onChange={(value)=>{console.log("fieldInfo.slug ",value);formikProps.setFieldValue(fieldInfo.slug, value)}}
                       formikProps={formikProps}
                       onBlur={formikProps.handleBlur}
                />
                {/* <input
          type="number"
          name={fieldInfo.name}
          value={formikProps.values[fieldInfo.slug]}
          onChange={formikProps.handleChange}
          onBlur={formikProps.handleBlur}
          className={`form-control${this.#isInvalidCss(
            fieldInfo,
            formikProps
          )}`}
        /> */}

                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>
        )
    }

    static #getNumberField(fieldInfo, formikProps) {
        return (
            <div className='m-2 w-100' key={fieldInfo.slug}>
                <label htmlFor={fieldInfo.name}
                       className={styles.label}>{fieldInfo.label}</label>
                <input
                    type='number'
                    name={fieldInfo.name}
                    value={formikProps.values[fieldInfo.slug]}
                    onChange={formikProps.handleChange}
                    onBlur={formikProps.handleBlur}
                    className={`form-control${this.#isInvalidCss(
                        fieldInfo,
                        formikProps,
                    )}`}
                />
                <ErrorMessage fieldInfo={fieldInfo} formikProps={formikProps} />
            </div>
        )
    }
}
